module.exports = __webpack_public_path__ + "img/logo.0bd130c6.png";